var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTabVehicles(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6096_19519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3327 12.6667H6.66602M15.3327 12.6667V9.33334L13.9993 6.00001H7.99935L6.63268 9.31667L6.66602 12.6667M15.3327 12.6667V13.6667M6.66602 12.6667V13.6667M14.566 8.66667H7.43268M0.666016 8.66667V12C0.666016 12.1768 0.736253 12.3464 0.861278 12.4714C0.986302 12.5964 1.15587 12.6667 1.33268 12.6667H4.66602M0.666016 8.66667V3.33334C0.666016 3.15653 0.736253 2.98696 0.861278 2.86193C0.986302 2.73691 1.15587 2.66667 1.33268 2.66667H8.66602C8.84283 2.66667 9.0124 2.73691 9.13742 2.86193C9.26244 2.98696 9.33268 3.15653 9.33268 3.33334V4.00001M0.666016 8.66667H4.66602M2.99935 13L2.33268 13.6667M13.3327 10.6693H13.3353V10.6667H13.3327V10.6693ZM8.66602 10.6693H8.66868V10.6667H8.66602V10.6693ZM2.66602 10.6693H2.66868V10.6667H2.66602V10.6693Z",
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6096_19519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabVehicles);
export default __webpack_public_path__ + "static/media/tab Vehicles.cd7e7e83cc1744bdfaf741fc2ca35659.svg";
export { ForwardRef as ReactComponent };